import React from "react";
import ReactPaginate from "react-paginate";
import {Select, Flex, HStack, Text} from "@chakra-ui/react";
import "./styles.css";
import {ReactComponent as RightIcon} from "../../assets/icons/pagination_right.svg";
import {ReactComponent as LeftIcon} from "../../assets/icons/pagination_left.svg";

export const PaginationRow = ({pageCount, width,onPageChange, itemsPerPage, onItemsPerPageChange, marginForTop}) => {

    const handlePageClick = ({selected}) => {
        onPageChange(selected);
    };
    console.log(marginForTop)
    return (
        <Flex
            w={width}
            color={'#fff'}
            justify="space-between"
            align="center"
            position={'relative'}
            mt={marginForTop}>
            <ReactPaginate
                previousLabel={<LeftIcon/>}
                nextLabel={<RightIcon/>}
                breakLabel="..."
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                activeClassName="active"/>
            <HStack
                w={{base: '77%',xs:'60%',"2sm": '38%',md:'20%',xm:'15%',lg:'12%'}}
                position={{base: 'unset',md: 'absolute'}}
                right={{base: 'unset', md: '0'}}
                bottom={{base: '-60px', md: '0'}}
                left={{base: '0', md: 'unset'}}
                fontSize={'body.sm'}
                color={'neutral.500'}
                top={'0'}>
                <Text whiteSpace={'nowrap'}>Rows count</Text>
                <Select
                    cursor={'pointer'}
                    variant={'unstyled'}
                    value={itemsPerPage}
                    onChange={(e) => onItemsPerPageChange(Number(e.target.value))}>
                    <option value={7}>7</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                </Select>
            </HStack>
        </Flex>
    );
};
